import { ProviderFeeInvoice } from "models/interfaces/providers/provider-fee-invoice";
import { Record } from "immutable";
// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: ProviderFeeInvoice = {
    id: 0,
    providerId: 0,
    invoiceTitle: "",
    productTypeId: 0,
    invoiceDate: new Date(),
    invoiceAmount: 0,
    notes: "",
    provider: undefined,
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class ProviderFeeInvoiceRecord extends Record(defaultValues) implements ProviderFeeInvoice {
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<ProviderFeeInvoice>) {
        params = params ?? Object.assign({}, defaultValues);

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    /**
     * Given a set of values for ProviderFeeInvoice properties, create a new ProviderFeeInvoiceRecord object from this
     * instance, overwriting the properties in the values parameter with values provided.
     *
     * @param {Partial<ProviderFeeInvoice>} values The values to overwrite on this instance.
     * @returns A ProviderFeeInvoiceRecord with values from this instance and the values parameter.
     */
    public with(values: Partial<ProviderFeeInvoice>): ProviderFeeInvoiceRecord {
        return new ProviderFeeInvoiceRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { ProviderFeeInvoiceRecord };

// #endregion Exports
